export enum MODE_THEME {
  DARK = 'dark',
  LIGHT = 'light',
}
